import React, { useState } from "react";
import { Modal, Spin, Button, Row, Col } from "antd";
import useCompanySearch from "../../../hooks/useCompanySearch";
import CompanyFilters from "../../../components/CompanyFilters/CompanyFilters";
import CompanySearchResults from "../../../components/CompanySearchResults/CompanySearchResults";
import { useSelector } from "react-redux";
import { l } from "../../../libs/localization";
import { getFeatures } from "../../../libs/features";
import usePermissions from "../../../hooks/usePermissions";
import { getFromLocalStorage } from "../../../libs/helpers/localstorage";

const AddCompanyModal = ({ visible, onClose, onSelect, excludeIds }) => {
  const {
    dataForm,
    setDataForm,
    results,
    loading,
    brandAdvertiserFilters,
    setBrandAdvertiserFilters,
    handleOrder,
    order,
    orderDir,
    pageSize,
    setPageSize,
    pageNum,
    setPageNum,
    handlePageChange,
    filters,
  } = useCompanySearch(5);

  const features = getFeatures();
  const permissions = usePermissions();
  const tenant = getFromLocalStorage("lefacWebTenant")?.data;

  return (
    <Modal
      title={l("PAGES.DASHBOARD.ADD_TO_COMPARISON")}
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={1200}
      bodyStyle={{ padding: "30px" }}
      className="add-company-modal"
    >
      <div className="add-company-modal__filters">
        <CompanyFilters
          dataForm={dataForm}
          setDataForm={setDataForm}
          features={features}
          permissions={permissions}
          tenant={tenant}
          loadingSearch={loading}
          brandAdvertiserFilters={brandAdvertiserFilters}
          setBrandAdvertiserFilters={setBrandAdvertiserFilters}
        />
      </div>

      <div className="add-company-modal__results" style={{ marginTop: 30 }}>
        <CompanySearchResults
          results={results}
          loading={loading}
          pageSize={pageSize}
          setPageSize={setPageSize}
          pageNum={pageNum}
          setPageNum={setPageNum}
          filters={filters}
          onRowClick={(item) => {
            onSelect(item._id);
            onClose();
          }}
          onPageChange={handlePageChange}
          resultsLimited={false}
          excludeIds={excludeIds}
          showAddButton={true}
          onAddAll={() => {
            const allIds = results?.companies?.data
              ?.slice(0, 5)
              .map((c) => c._id);
            if (allIds && allIds.length > 0) {
              onSelect(allIds);
              onClose();
            }
          }}
        />
      </div>
    </Modal>
  );
};

export default AddCompanyModal;
